module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff2?455ea818179b4def0c432c45ac2291c9";